import { Provider as ReactReduxProvider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./contexts/Auth";
import store from "./store";
import theme from "./theme";

import { routeObject } from "./routes";

const router = createBrowserRouter(routeObject);

export default function App() {
  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <ReactReduxProvider store={store}>
          <SnackbarProvider
            preventDuplicate
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            autoHideDuration={5000}
          >
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </SnackbarProvider>
        </ReactReduxProvider>
      </ThemeProvider>
    </>
  );
}
